import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_FINANCIAL_RECORD_URL

const _get = async (queryParamFilters, queryParam, setParams, setMetadata) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParamFilters || undefined,
  }

  setParams?.(params)

  const response = await apiClientV2({
    method: 'GET',
    baseURL,
    url: '/template',
    params: params,
  })

  setMetadata?.(response?.data.metadata)

  return response?.data
}

export const get = (queryParamFilters, setParams, setMetadata) => async (queryParam) =>
  await _get(queryParamFilters, queryParam, setParams, setMetadata)

export const show = async (id) => {
  const response = await apiClientV2({
    method: 'GET',
    baseURL,
    url: `/template/${id}`
  })

  return response?.data
}

export const store = async (data) => {
  const response = await apiClientV2({
    method: 'POST',
    baseURL,
    url: '/template',
    data,
  })

  return response?.data
}

export const update = async (id, data) => {
  const response = await apiClientV2({
    method: 'PATCH',
    baseURL,
    url: `/template/${id}`,
    data,
  })

  return response?.data
}

export const deleteMany = async (data) => {
  const response = await apiClientV2({
    method: 'DELETE',
    baseURL,
    url: '/template/bulk',
    data,
  })

  return response?.data
}

export const getItems = async (id, params) => {
  const { data: { data } } = await apiClientV2({
    method: 'GET',
    baseURL,
    url: `/template/${id}`,
    params
  })

  return data.details
}
